import apiClient from '@/clients/apiClient';

export const generateDataIntegrityReport = (formData) =>
  apiClient.post('reports/data-integrity', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
